import mongoose from 'mongoose';
import schema, { IUserReviewDocument } from '../schemas/user-review';

const UserReview = (mongoose.models.UserReview ||
  mongoose.model('UserReview', schema)) as mongoose.Model<IUserReviewDocument>;

export default UserReview;
